// src/redux/userSettingsSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const userSettingsSlice = createSlice({
  name: "userSettings",
  initialState: {
    theme: "light", // Default theme
    language: "en", // Default language
  },
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setTheme, setLanguage } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
